function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("circle", {
  cx: 226.367,
  cy: 312.667,
  r: 6,
  transform: "rotate(-6.80312 226.367 312.667)",
  fill: "#EB34A6"
}), React.createElement("circle", {
  cx: 200.672,
  cy: 426.512,
  r: 3,
  transform: "rotate(-6.80312 200.672 426.512)",
  fill: "#EB34A6"
}), React.createElement("circle", {
  cx: 421.774,
  cy: 414.235,
  r: 3,
  transform: "rotate(-6.80312 421.774 414.235)",
  fill: "#EB34A6"
}), React.createElement("circle", {
  cx: 213.626,
  cy: 129.889,
  r: 3,
  transform: "rotate(-6.80312 213.626 129.889)",
  fill: "#EB34A6"
}), React.createElement("circle", {
  cx: 51.5328,
  cy: 324.461,
  r: 3,
  transform: "rotate(-6.80312 51.5328 324.461)",
  fill: "#EB34A6"
}), React.createElement("circle", {
  cx: 354.58,
  cy: 121.13,
  r: 5,
  transform: "rotate(-6.80312 354.58 121.13)",
  fill: "#EB34A6"
}), React.createElement("circle", {
  cx: 447.56,
  cy: 284.265,
  r: 4,
  transform: "rotate(-6.80312 447.56 284.265)",
  fill: "#EB34A6"
}), React.createElement("path", {
  d: "M610.945 345.341L554.416 538.396L317.123 474.053L199.679 426.631L53.4647 488.386L50.5398 324.579L213.129 129.949L353.706 122.242L578.672 7.28343L519.309 163.918L610.945 345.341Z",
  stroke: "#EB34A6"
}), React.createElement("path", {
  d: "M225.93 313.223L200.175 426.572L51.0363 324.52L225.93 313.223Z",
  stroke: "#EB34A6"
}), React.createElement("path", {
  d: "M421.337 414.79L317.62 473.993L225.87 312.726L421.337 414.79Z",
  stroke: "#EB34A6"
}), React.createElement("path", {
  d: "M421.337 414.79L554.912 538.337L448.056 284.206L421.337 414.79Z",
  stroke: "#EB34A6"
}), React.createElement("path", {
  d: "M226.048 314.216L353.647 121.745L518.931 164.971L226.048 314.216Z",
  stroke: "#EB34A6"
}), React.createElement("path", {
  d: "M610.508 345.896L447.619 284.761L518.931 164.971",
  stroke: "#EB34A6"
}), React.createElement("path", {
  d: "M447.619 284.761L226.544 314.156L213.685 130.386",
  stroke: "#EB34A6"
}));

var SvgRightBottomBg = function SvgRightBottomBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 456 465",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRightBottomBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rightBottomBg.9d2ab173.svg";
export { ForwardRef as ReactComponent };